/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import PrivateImage from 'Modules/PrivateImage/PrivateImage';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Divider } from 'semantic-ui-react';

import styles from './MedicalCertificatePreview.less';

const displayFormat = 'YYYY-MM-DD';

class CertificatePreview extends Component {
  static propTypes = {
    patientName: PropTypes.string,
    patientNric: PropTypes.string,
    certTypeId: PropTypes.number,
    doctorName: PropTypes.string.isRequired,
    signatureUrl: PropTypes.string,
    startDate: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.shape({}).isRequired]),
    days: PropTypes.number,
    clinicId: PropTypes.number,
    emc: PropTypes.shape({}).isRequired,
    certification: PropTypes.shape({
      data: PropTypes.shape({}),
      latestCertification: PropTypes.shape({
        signFileInfo: PropTypes.shape({}),
      }),
    }).isRequired,
    formData: PropTypes.shape({}).isRequired,
    isBookForSelf: PropTypes.bool,
    nric: PropTypes.string,
    name: PropTypes.string,
    dateOfBirth: PropTypes.string,
    clinicLogo: PropTypes.shape({}),
    clinicChop: PropTypes.shape({}),
  };

  renderSignatureImage = () => {
    const { signatureUrl } = this.props;

    if (signatureUrl) {
      return (
        <PrivateImage
          src={signatureUrl}
          alt="signature"
          className={styles.signature}
          style={{ maxWidth: 100 }}
        />
      );
    }
    return null;
  };

  render() {
    const {
      certification: {
        latestCertification: { doctorInfo },
      },
      doctorName,
      emc: {
        certType: { certTypes },
      },
      description,
      formData,
      clinicLogo,
      clinicChop,
    } = this.props;

    const {
      clinic: clinicId,
      patientName,
      startDate,
      numberOfDays: days,
      medicalLeaveGrantedType: certTypeId,
      nricPassportNumber: patientNric,
      diagnosis,
    } = formData || {
      clinic: null,
      qualification: '',
      patientName: '',
      startDate: null,
      numberOfDays: 0,
      medicalLeaveGrantedType: '',
      nricPassportNumber: '',
      signaturePad: '',
      diagnosis: '',
    };
    const clinics = this.props.emc.clinic.list;

    const clinicObject = (clinics && clinics.find(clinic => clinic.id === clinicId)) || {};
    const { name: clinicName, address } = clinicObject;

    const dateValue = typeof startDate === 'object' && startDate ? startDate._d : startDate;
    const startDateFormatted = moment(dateValue).format(displayFormat);
    const endDate = moment(dateValue)
      .add(days - 1, 'days')
      .format(displayFormat);

    const certTypeObj = certTypes && certTypes.find(certType => certType.id === certTypeId);

    let note = certTypeObj && certTypeObj.content;
    if (note && note.includes('{{ days }}')) {
      note = note.replace('{{ days }}', days);
    }

    if (note && note.includes('{{ start_date }}')) {
      const mapObj = {
        '{{ start_date }}': startDateFormatted,
        '{{ end_date }}': endDate,
      };
      const re = new RegExp(Object.keys(mapObj).join('|'), 'gi');
      note = note.replace(re, matched => mapObj[matched]);
    }

    const certTypeName = certTypeObj && certTypeObj.name;

    const licenseNo =
      doctorInfo && doctorInfo.professions && doctorInfo.professions[0]
        ? doctorInfo.professions[0].licenseNo
        : undefined;
    const title = doctorInfo && doctorInfo.title;

    return (
      <div className={styles.preview}>
        <div className={styles.body}>
          <div className={styles.header}>
            {!!clinicLogo && (
              <div className={styles.clinicLogoWrapper}>
                <img src={clinicLogo.previewPath} alt="logo" className={styles.clinicLogo} />
              </div>
            )}
            <h1 className={styles.clinic}>{clinicName}</h1>
            <div className={styles.address}>{address}</div>
            {/* <p className={styles.tel}>{`Tel: ${phoneCountryCode} ${phoneNumber}`}</p> */}
          </div>
          <Divider />
          <div className={styles.content}>
            <div className={styles.title}>
              <h1>MEDICAL CERTIFICATE</h1>
            </div>
            <div>
              <p>
                <span>Name: </span>
                <strong className={styles.wordWrap}>{patientName}</strong>
              </p>
              <p>
                <span>NRIC / Passport number: </span>
                <strong className={styles.wordWrap}>{patientNric}</strong>
              </p>

              <div className={styles.date}>
                <p>
                  <span>Start date: </span>
                  <strong>{startDateFormatted}</strong>
                </p>
                <p>
                  <span>End date: </span>
                  <strong>{endDate}</strong>
                </p>
              </div>
              {!!diagnosis?.trim() && (
                <p>
                  <span>Diagnosis: </span>
                  <strong>{diagnosis}</strong>
                </p>
              )}
              <p>
                <span>Type of medical leave granted: </span>
                <strong>{certTypeName}</strong>
              </p>
              <p className={styles.note}>{note}</p>
              {!!clinicChop && (
                <div className={styles.clinicChopWrapper}>
                  <img src={clinicChop.previewPath} alt="logo" className={styles.clinicChop} />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.footerPreview}>
          <div className={styles.footer}>
            {this.renderSignatureImage()}
            <div className={styles.doctor}>
              <div>
                <strong>Dr. {doctorName}</strong>
              </div>
              <div>{title}</div>
              {licenseNo && <div>{`License No: ${licenseNo}`}</div>}
              <div className={styles.qualification}>{description}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CertificatePreview.defaultProps = {
  patientName: 'patientName',
  patientNric: 'patientNric',
  signatureUrl: null,
  startDate: moment().format(displayFormat),
  clinicId: 1,
  certTypeId: 1,
  days: 1,
  isBookForSelf: true,
  nric: 'nric',
  name: '',
  dateOfBirth: '',
  clinicLogo: null,
  clinicChop: null,
};
const mapStateToProps = state => ({
  doctorName:
    state.doctors.profile?.name ||
    `${state.doctors.profile?.firstName} ${state.doctors.profile?.lastName}`,
  emc: state.webChat.emc,
  certification: state.webChat.emc.certification,
});

export default connect(mapStateToProps)(CertificatePreview);
